import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { GET_ONBOARDING, SET_ONBOARDING } from './constants';

const initialState = {
  intros: {},
  tooltips: {},
  dbValues: {},
};

export const onboardingReducer = createReducer(initialState, {
  [`${GET_ONBOARDING}_SUCCESS`]: (state, action) => {
    return action.payload;
  },

  [`${SET_ONBOARDING}_SUCCESS`]: (state, action) => {
    return action.payload;
  },
});
